export default __webpack_public_path__ + "ca8330b8d49ea4aece83cc30a79e1f9a.webp";